import { useEffect, useState } from 'react';
import { useFeatureFlags as useLibraryFeatureFlags } from '@janeapp/feature-flags-client/react';
import { initFeatureFlags } from '@janeapp/feature-flags-client';
import { FeatureFlagsApi } from '~/api';
import { getBaseUrl } from '~/env';
import { logErrorToSentry, ErrorLevel } from '~/utilities';

export const useFeatureFlags = () => {
  const { featureFlags } = useLibraryFeatureFlags();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const api = new FeatureFlagsApi({ baseUrl: getBaseUrl() });

    const fetchFlags = async () => {
      const response = await api.getClientConfig();
      return await response.json();
    };

    const initialize = async () => {
      let attempt = 0;
      const maxAttempts = 2;

      while (attempt < maxAttempts) {
        try {
          await initFeatureFlags(fetchFlags);
          setIsInitialized(true);
          return;
        } catch (error) {
          attempt++;

          if (attempt >= maxAttempts) {
            logErrorToSentry({
              type: ErrorLevel.Error,
              message: `Failed to initialize feature flags after ${maxAttempts} attempts: ${error}`,
            });
            setIsInitialized(true);
            return;
          }

          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
      }
    };

    initialize();
  }, []);

  return {
    featureFlags,
    isInitialized,
  };
};
